import { createFileRoute } from '@tanstack/react-router';
import UnverifiedEmailPage from '../../components/shared/authentication/UnverifiedEmailPage';

export const Route = createFileRoute('/_authenticated/verify-email')({
  component: UnverifiedEmailPage,
  staticData: {
    accountOptional: true,
    hideHeader: true,
    meta: {
      title: 'Verify Email | Ledgible',
    },
  },
});
